module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/UploadYourOwn_Mobile-7848d826e629b5a4961599f8ff88d264.png";